import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { IncidentTypesPage } from "@/pages/dashboard/incident-report-types/list";

export const Route = createFileRoute("/_main/dashboard/incident-report-types/")({
  component: () => (
    <RequirePermission action="lookups.manage">
      <IncidentTypesPage />
    </RequirePermission>
  ),
});
